import templateUrl from './edit-lead-status-modal.component.html'

import { androidHues, getHexColorByHue } from '../../../common/components/color/color-utils'
import { StatusTypeEnum } from '../../../core/services/data-services/leads.service';
import { IFormController } from 'angular';

export const EditLeadStatusModal = {
    templateUrl,
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    },
    controller: class EditLeadStatusModal {
        hues = Object.keys(androidHues)
            .map(key => ({
                name: key,
                hue: androidHues[key],
                color: getHexColorByHue(androidHues[key])
            }))
        leadStatus: any;
        resolve: any;
        selectedHue: any;
        declaration: boolean;
        observation: boolean;
        interaction: any;
        editForm: IFormController;
        close: (arg0: any) => void;
        constructor() {
        }

        $onInit() {
            this.leadStatus = this.resolve.leadStatus
            const statusType = this.leadStatus.leadStatusType || 0
            this.selectedHue = this.hues.find(p => p.hue === this.leadStatus.hue)
            this.declaration = (statusType & StatusTypeEnum.Declaration) !== 0
            this.observation = (statusType & StatusTypeEnum.Observation) !== 0
            this.interaction = (statusType & StatusTypeEnum.Interaction) !== 0
        }

        onChangeLeadStatusType() {
            this.leadStatus.leadStatusType = (this.declaration ? StatusTypeEnum.Declaration : 0)
                | (this.observation ? StatusTypeEnum.Observation : 0)
                | (this.interaction ? StatusTypeEnum.Interaction : 0)
        }

        /**
         * Change the lead status' hue based on the event data.
         * @param {{hue : number}} $event The event containing the updated hue value.
         */
        onChangeHue(hue) {
            this.leadStatus.hue = this.selectedHue
                ? this.selectedHue.hue : null
        }

        /**
         * Use the colour from the selected hue as the lead's hex code colour.
         */
        onUseHueColor() {
            if (!this.selectedHue) return
            this.leadStatus.color = this.selectedHue.color
        }

        onSave() {
            if (this.editForm && !this.editForm.$valid) {
                return
            }
            return this.close({ $value: this.leadStatus })
        }
    }
}
